// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const GraphicProductResourcesRight: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="405" height="389" viewBox="0 0 405 389" fill="currentColor">
            <polygon
                fill="#999"
                fillRule="evenodd"
                points="1079.161 0 1366 0 1366 389 961 389"
                opacity=".33"
                transform="translate(-961)"
            />
        </svg>
    );
};

export default React.memo(GraphicProductResourcesRight);
